import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Response } from '../interfaces/http/http.interface';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs';
import { Product, ProductCategory } from '../interfaces/products/product.interface';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  private http = inject(HttpClient);

  constructor() {}

  fetchProducts() {
    return this.http.get<Response>(environment.APP_URL + '/products').pipe(
      map((res: Response) => {
        return res.data as Product[];
      }),
    );
  }

  fetchOneProduct = (id: any) => {
    return this.http
      .get<Response>(environment.APP_URL + '/products/' + id)
      .pipe(
        map((res: Response) => {
          return res.data as Product;
        }),
      );
  };

  createProduct = (data: any) => {
    return this.http
      .post<Response>(environment.APP_URL + '/products', data)
      .pipe(
        map((res: Response) => {
          return res.data as Product;
        }),
      );
  };

  editProduct = (data: any) => {
    return this.http
      .put<Response>(environment.APP_URL + '/products', data)
      .pipe(
        map((res: Response) => {
          return res.data as Product;
        }),
      );
  };

  deleteProduct = (data: Product) => {
    return this.http
      .delete<Response>(environment.APP_URL + '/products', {
        body: { id: data.id },
      })
      .pipe(
        map((res: Response) => {
          return res.data as Product;
        }),
      );
  };

  fetchCategories() {
    return this.http.get<Response>(environment.APP_URL + '/product-categories').pipe(
      map((res : Response) => {
        return res.data as ProductCategory[];
      })
    )
  }

  importProducts = (data: any) => {
    return this.http.post<Response>(environment.APP_URL + '/products/import', data).pipe(
      map((res: Response) => {
        return res.data;
      })
    )
  } 
}
